import { SettingsType } from "adviesbox-shared";
import { RouteParams } from "../../shared/paramrouting/paramrouting-context";

export const createWoonsituatieUrl = (s: SettingsType, p: RouteParams): string =>
  `${s.klantdossiersFormsOrigin}/Adviesdossiers/${p.adviesdossier}/Woonsituatie`;

export const getDossierId = (p: RouteParams): string => p.adviesdossier;
